import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  width: 100%;\n  max-width: 30px;\n  height: auto;\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n        \n      "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n        \n      "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n        \n      "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n        font-size: 12px;\n      "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n        font-size: 14px;\n      "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  div {\n    padding: 0;\n    background-color: transparent;\n    color: ", ";\n\n    > span {\n      padding-bottom: 2px;\n      font-family: ", ";\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 100%;\n      color: #4F6E7C;\n      ", "\n      ", "\n    }\n\n    button {\n      opacity: 0.2;\n      ", "\n      ", "\n      ", "\n      svg {\n        path {\n          fill: #2C2C2C;\n        }\n      }\n    }\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      font-size: 12px;\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      font-size: 14px;\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n\n  > span {\n    display: flex;\n    align-items: center;\n    font-family: ", ";\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 100%;\n    color: #4f6e7c;\n    opacity: 0.8;\n    ", "\n    ", "\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    width: 107px;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    width: 167px;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    width: 140px;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.8rem 1rem;\n  height: 100%;\n  width: 196px;\n  background-color: ", ";\n    pointer-events: ", ";\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  min-width: 110px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      padding: 0.75rem;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  input {\n    padding: 1rem;\n    ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Button } from "@components/atoms";
import { media, styled } from "@styles";
export var DiscountForm = styled.form(_templateObject(), function (props) {
  return props.theme.spacing.spacer;
});
export var Input = styled.div(_templateObject2(), function (props) {
  return props.theme.spacing.spacer;
});
export var InputWithButton = styled.div(_templateObject3());
export var InputWrapper = styled.div(_templateObject4(), media.xxLargeScreen(_templateObject5()));
export var ButtonWrapper = styled.div(_templateObject6());
export var StyledButton = styled(Button)(_templateObject7(), function (props) {
  return props.active ? props.theme.colors.red : "#DADEE0";
}, function (props) {
  return props.active ? "all" : "none";
}, media.xxLargeScreen(_templateObject8()), media.largeScreen(_templateObject9()), media.mediumScreen(_templateObject10()));
export var PromoCodeValue = styled.div(_templateObject11(), function (props) {
  return props.theme.typography.extraFontFamily;
}, media.xxLargeScreen(_templateObject12()), media.mediumScreen(_templateObject13()));
export var ChipsWrapper = styled.div(_templateObject14(), function (props) {
  return props.theme.colors.red;
}, function (props) {
  return props.theme.typography.extraFontFamily;
}, media.xxLargeScreen(_templateObject15()), media.mediumScreen(_templateObject16()), media.xxLargeScreen(_templateObject17()), media.largeScreen(_templateObject18()), media.mediumScreen(_templateObject19()));
export var Spinner = styled.img(_templateObject20(), function (props) {
  return props.cHidden ? "block" : "none";
});